module.exports = __webpack_public_path__ + "img/carlos4.22943f2f.jpg";